import React, { useState, useLayoutEffect } from 'react';
import { findDOMNode } from 'react-dom';

export default function(domRef: React.RefObject<Element>) {
  const [height, setHeight] = useState<string>('');
  useLayoutEffect(() => {
    if (domRef && domRef.current) {
      const dom = findDOMNode(domRef.current) as Element;
      setHeight(getComputedStyle(dom).height || '0px');
    }
  }, []);
  return height;
}
